import Api from "../../../Api";

const GetRandomRecipes = (setMeals) => {
  Api.Meals.random(5).then((response) => {
    setMeals(response.data);
  });
};

export default GetRandomRecipes;
